const SERVICE_TYPES = {
    COMMUNITY: 'cs',
    PROGRAM_ENGINE: 'pe',
    ADMINS: 'usr',
    VIDEO_HOSTING: 'vhs',
};

export default SERVICE_TYPES;
